<template>
  <v-main>
    <v-card width="412" class="mx-auto py-5" :elevation="$vuetify.breakpoint.xsOnly ? 0 : 2" style="margin-top: 70px; z-index: 1">
      <v-card-title class="justify-center font-weight-bold text-h5">牙醫小幫手管理後台</v-card-title>
      <v-card-text>
        <v-container fluid>

          <!-- 登入類型選擇 -->
          <v-row no-gutters style="row-gap: 20px;">
            <v-col cols="12">請選擇登入方式：</v-col>
            <v-col cols="12">
              <v-btn
                block
                outlined
                :color="loginType === '1' ? 'tiffany-9' : 'grey lighten-1'"
                height="77"
                class="py-6 px-5 justify-start rounded-lg"
                :style="loginType === '1' ? 'background: var(--v-tiffany-11-base)' : ''"
                @click="selectLoginType('1')"
              >
                <div class="d-flex" style="column-gap: 20px" :class="{'tiffany-8--text': loginType === '1'}">
                  <v-icon large>mdi-home</v-icon>
                  <div class="text-left">
                    <div
                      :class="{'grey--text text--darken-2': loginType !== '1', 'font-weight-bold': loginType === '1'}"
                    >診所登入</div>
                    <div :class="{'font-weight-regular': loginType === '1'}">管理全院約診及功能設定</div>
                  </div>
                </div>
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-btn
                block
                outlined
                :color="loginType === '2' ? 'tiffany-9' : 'grey lighten-1'"
                height="77"
                class="py-6 px-5 justify-start rounded-lg"
                :style="loginType === '2' ? 'background: var(--v-tiffany-11-base)' : ''"
                @click="selectLoginType('2')"
              >
                <div class="d-flex" style="column-gap: 20px" :class="{'tiffany-8--text': loginType === '2'}">
                  <v-icon large>mdi-account-circle</v-icon>
                  <div class="text-left">
                    <div :class="{'grey--text text--darken-2': loginType !== '2', 'font-weight-bold': loginType === '2'}">醫師登入</div>
                    <div :class="{'font-weight-regular': loginType === '2'}">編輯醫師頁面，管理約診和評價</div>
                  </div>
                </div>
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-form ref="form" v-model="valid" class="mt-4 d-flex flex-column" style="row-gap: 20px;" @submit.prevent="submit">
                <v-text-field
                  v-if="loginType === '1'"
                  autofocus
                  :label="$t('LOGIN.account')"
                  v-model="account"
                  :rules="[v => !!v || $t('LOGIN.inputAccount')]"
                  required
                  dense
                  outlined
                  hide-details="auto"
                ></v-text-field>
                <v-text-field
                  v-else
                  autofocus
                  :label="$t('LOGIN.phone')"
                  v-model="account"
                  :rules="[v => !!v || $t('LOGIN.inputPhone')]"
                  required
                  dense
                  outlined
                  hide-details="auto"
                ></v-text-field>
                <v-text-field
                  :label="$t('LOGIN.password')"
                  v-model="password"
                  required
                  :rules="[v => !!v || $t('LOGIN.inputPassword')]"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  dense
                  outlined
                  hide-details="auto"
                  @click:append="showPassword = !showPassword"
                ></v-text-field>
                <div v-if="loginType === '2'" class="text-right">
                  <v-btn small text color="primary" class="pa-1" height="24" @click="forgetPassword = true">忘記密碼？</v-btn>
                </div>
                <v-btn type="submit" :disabled="!valid" block :dark="valid" color="tiffany-9" elevation="0">{{ $t('LOGIN.login') }}</v-btn>
              </v-form>
            </v-col>
          </v-row>
          <div class="d-flex align-center mt-7">
            <span class="black--text">還沒有帳號嗎？</span>
            <v-btn v-if="loginType === '1'" small text dark color="tiffany-9" @click="clickRegisterDoctor">聯絡客服</v-btn>
            <template v-if="loginType === '2'">
              <v-btn small text dark color="tiffany-9" @click="clickRegisterDoctor">{{ $t('LOGIN.registerDoctor') }}</v-btn>
              <v-tooltip top max-width="500">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small>
                    <v-icon color="grey lighten-1" small v-bind="attrs" v-on="on" @click="alertDialog = true">mdi-help-circle-outline</v-icon>
                  </v-btn>
                </template>
                <div class="py-4 px-2">
                  ✅ 編輯專屬的醫師頁面資訊<br>
                  ✅ 管理網路評價<br>
                  ✅ 瀏覽約診 (診所有同步的話)
                </div>
              </v-tooltip>
            </template>
          </div>
          <v-divider class="my-6"/>
          <v-btn block color="black" dark href="$enum.DENTCO_CS_LINE" target="_blank">
            <v-icon>mdi-face-agent</v-icon>
            {{ $t('LOGIN.CS') }}
          </v-btn>
          <v-dialog v-if="forgetPassword" v-model="forgetPassword" max-width="420" scrollable>
            <forget-password @close="forgetPassword = false"/>
          </v-dialog>
          <v-dialog v-if="registerDialog" v-model="registerDialog" max-width="532" scrollable>
            <RegisterDoctorFormV2 @close="registerDialog = false"/>
          </v-dialog>
          <v-dialog v-model="alertDialog" max-width="400">
            <v-card class="pa-4" rounded="lg">
              <v-btn
                fab
                icon
                absolute
                width="48"
                height="48"
                style="top: 0; right: 0; overflow: hidden;"
                @click="alertDialog = false;"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-card-title class="text-center d-block">
                註冊後您將能夠 <span class="tiffany-9--text">免費獲得</span>
              </v-card-title>
              <v-card-text>
                <v-sheet class="py-4 px-2 ma-auto" max-width="240">
                  ✅ 編輯專屬的醫師頁面資訊<br>
                  ✅ 管理網路評價<br>
                  ✅ 瀏覽約診 (診所有同步的話)
                </v-sheet>
              </v-card-text>
              <v-card-actions class="mt-2 px-4 px-md-6">
                <div style="width: 100%;">
                  <v-btn color="tiffany-9" dark block @click="registerDialog = true;alertDialog = false;">
                    前往註冊
                  </v-btn>
                </div>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-container>
      </v-card-text>
    </v-card>
    <v-img height="280" position="center 0" src="https://dentco.s3.us-east-2.amazonaws.com/asset/green_background.png" style="position: absolute; bottom: 0;"
           width="100%"/>

  </v-main>
</template>

<script>
import ForgetPassword from "@/components/ForgetPassword";
import RegisterDoctorFormV2 from "@/components/login/RegisterDoctorFormV2";
import { loginAPI } from "@/api";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { sendDiscordAlert } from "@/utils/tool";

export default {
  name: "Login",
  components: {RegisterDoctorFormV2, ForgetPassword},
  data() {
    return {
      valid: true,
      account: '',
      password: '',
      showPassword: false,
      loginType: null,
      registerDialog: false,
      forgetPassword: false,
      alertDialog: false
    }
  },
  computed: {
    ...mapGetters([
      'isSpecialClinic',
    ])
  },
  methods: {
    ...mapMutations({
      setUserData: 'setUserData',
      setPermissions: 'userInfo/setPermissions'
    }),
    ...mapActions({
      getDoctorEmail: 'getDoctorEmail'
    }),
    selectLoginType(type) {
      this.loginType = type
      this.resetValidation()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    submit() {
      if (!this.valid) return

      const data = {
        account: this.account,
        type: this.loginType,
      }
      loginAPI({
        password: this.password,
        ...data
      }).then(async res => {
        this.setUserData(res.data)
        this.setPermissions(res.data?.permissions)
        await this.$store.dispatch('loadUserInfo', { force: true })
          .catch(err => console.error('loadUserInfo failed after login', err))
        const nextPage = this.$router.currentRoute.query.next
        if (nextPage && nextPage !== '/login') this.$router.push(nextPage)
        else if (this.isSpecialClinic) this.$router.push({name: 'onlineReserve'})
        else this.$router.push('/')
      }).catch(e => {
        if (e.response) {
          // 有打到後端（後端錯誤）
          const messages = e.response.data?.messages

          if (messages) {
            // 後端有提供明確錯誤訊息
            this.$notify.error(messages)
          } else {
            // 有打到後端，但後端沒有提供錯誤訊息
            this.$notify.error(this.$t('GENERAL.oops'))
            console.error('後端錯誤但無訊息:', e.response)

            try {
              const errorInfo = JSON.stringify({
                message: e.message,
                stack: e.stack,
                code: e.code,
                responseStatus: e.response?.status,
                responseData: e.response?.data,
              }, null, 2)

              const dataInfo = JSON.stringify(data, null, 2)
              sendDiscordAlert(
                `登入發生錯誤：後端有回應但未提供錯誤訊息。\ndata: ${dataInfo}\nerror: ${errorInfo}`
              )
            } catch (alertErr) {
              console.error('sendDiscordAlert 發送失敗:', alertErr)
              // ❗但不做 alert，不打擾使用者
            }
          }
        } else if (e.message === 'Network Error') {
          // 沒有網路 / 無法連線到伺服器
          this.$notify.error('網路錯誤，請確認您的連線')
        } else if (e.code === 'ECONNABORTED') {
          // 請求逾時
          this.$notify.error('請求逾時，請稍後再試')
        } else {
          // 其他未知錯誤（可能是 CORS 問題或前端程式錯誤）
          this.$notify.error('發生未知錯誤，請稍後再試')
          console.error('未知錯誤:', e)

          try {
            const errorInfo = JSON.stringify({
              message: e.message,
              stack: e.stack,
              code: e.code,
              responseStatus: e.response?.status,
              responseData: e.response?.data,
            }, null, 2)

            const dataInfo = JSON.stringify(data, null, 2)
            sendDiscordAlert(
              `登入發生未知錯誤。\ndata: ${dataInfo}\nerror: ${errorInfo}`
            )
          } catch (alertErr) {
            console.error('sendDiscordAlert 發送失敗:', alertErr)
            // ❗但不做 alert，不打擾使用者
          }
        }
      })
    },
    clickRegisterDoctor() {
      this.registerDialog = true
      this.$gtm.trackEvent({
        event: 'crm_register_doctor'
      });
    }
  },
  mounted() {
    this.loginType = this.$route.query.type || '1'
  },
}
</script>

<style scoped>

</style>